const BOOKING_STATUS_LABELS = {
  booked: "Confirmed",
  confirmed: "Confirmed",
  unconfirmed: "Unconfirmed",
  cancelled: "Cancelled",
  canceled: "Cancelled",
  attended: "Attended",
  no_show: "No-Show",
  absent: "Absent",
  pending: "Pending",
};

/**
 * Display label for a booking's `status`. Shared by the Bookings list and the
 * Overview's Event Details so one booking reads the same everywhere.
 */
export function bookingStatusLabel(status) {
  const raw = String(status ?? "");
  return BOOKING_STATUS_LABELS[raw.toLowerCase()] || raw || "—";
}

/**
 * Color tone for a booking's `status`: "confirmed", "attended", "absent", or
 * "pending" for anything not yet confirmed or marked.
 */
export function bookingStatusTone(status) {
  const s = String(status ?? "").toLowerCase();
  if (s === "booked" || s === "confirmed") return "confirmed";
  if (s === "attended") return "attended";
  if (s === "absent" || s === "no_show") return "absent";
  return "pending";
}
